import { FunctionDefinitionEditor } from './FunctionDefinitionEditor';
export default {
  __init__: ['functionDefinition'],
  functionDefinition: ['type', FunctionDefinitionEditor]
};
//# sourceMappingURL=editor.js.map